define(
	'Digi.LoginRedirect.LoginRedirect'
,   [
		'LoginRegister.Login.View',
		'LoginRegister.Register.View',
		'Digi.LoginRedirect.LoginRedirect.Model',
		'Utils',
		'Profile.Model',
		'SC.Configuration'
	]
,   function (
		LoginRedirectView,
		RegisterRedirectView,
		DigiLoginRedirectModel,
		Utils,
		ProfileModel,
		Configuration
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			if (
				LoginRedirectView
				&& _.isFunction(LoginRedirectView.prototype.redirect)
			) {
				LoginRedirectView.prototype.redirect = _.wrap(LoginRedirectView.prototype.redirect, function (fn) {

					// console.log("arguments: ", _.toArray(arguments).slice(1));

					var url_options = Utils.parseUrlOptions(window.location.search);

					var self = this;
					var response = _.toArray(arguments).slice(1)[1];
					var email = response.user.email;
					var companyname = response.user.companyname;
					var companyid = response.user.internalid;
					var firstname = response.user.firstname;
					var lastname = response.user.lastname;

					if (url_options.redirect) {
						var userObj = new userObject();
						userObj.email = email;
						userObj.companyname = companyname;
						userObj.companyid = companyid;
						userObj.firstname = firstname;
						userObj.lastname = lastname;

						var contactInfo = new DigiLoginRedirectModel();
						contactInfo.fetch({ data: 'type=login' }).done(function(data) {

							var url = new URL('https://' + url_options.redirect);
							url.searchParams.append('email', email);
							url.searchParams.append('companyname', companyname);
							url.searchParams.append('companyid', companyid);

							// console.log('data', data);

							if (data.isContact) {
								url.searchParams.append('firstname', data.firstName);
								url.searchParams.append('lastname', data.lastName);
								url.searchParams.append('contactid', data.internalid)
							} else {
								url.searchParams.append('firstname', firstname);
								url.searchParams.append('lastname', lastname);
							}

							url.toString();
							// console.log('url',url);

							// debugger;

							self.trackEvent(redirectUrl(url));
						});

						//var url = new URL('https://' + url_options.redirect);
						//this.trackEvent(redirectPost(url, userObj));
	                } else {
	                	fn.apply(this, _.toArray(arguments).slice(1));
					}
				})
			}
			if (
				RegisterRedirectView
				&& _.isFunction(RegisterRedirectView.prototype.redirect)
			) {
				RegisterRedirectView.prototype.redirect = function (context, response) {
					// debugger;
					var self = this;
					return this.cancelableTrigger('after:LoginRegister.register').then(function () {
						var url_options = Utils.parseUrlOptions(window.location.search);
						var touchpoints = response.touchpoints;
						var application = self.application;
						// console.log('url_options', url_options);
						if (url_options.redirect) {
							//debugger;
							// console.log('response', response);
							var email = response.user.email;
							var companyname = response.user.companyname;
							var firstname = response.user.firstname;
							var lastname = response.user.lastname;
							var companyid = response.user.internalid;

							var userObj = new userObject();
							userObj.email = email;
							userObj.companyname = companyname;
							userObj.companyid = response.user.internalid;
							userObj.firstname = firstname;
							userObj.lastname = lastname;

							var contactInfo = new DigiLoginRedirectModel();
							contactInfo.fetch({ data: 'type=registration' }).done(function(data) {
								var url = new URL('https://' + url_options.redirect);
								url.searchParams.append('email', email);
								url.searchParams.append('companyname', companyname);
								url.searchParams.append('companyid', companyid);

								// console.log('data', data);

								if (data.internalid) {
									url.searchParams.append('contactid', data.internalid);
									url.searchParams.append('firstname', data.firstName);
									url.searchParams.append('lastname', data.lastName);
								}

								url.toString();
								// console.log('url',url);

								// debugger;

								self.trackEvent(redirectUrl(url));
							});

							//var url = new URL('https://' + url_options.redirect);
							//self.trackEvent(redirectPost(url, userObj));
						}else if (url_options.is && url_options.is === 'checkout') {
							var profile_model = ProfileModel.getInstance();
							response.user && profile_model.set(response.user);
							response.cart && LiveOrderModel.getInstance().set(response.cart);
							response.address && profile_model.get('addresses').reset(response.address);
							response.paymentmethod &&
								profile_model.get('paymentmethods').reset(response.paymentmethod);
							// Track Guest Checkout Event
							self.trackEvent(function () {
								application.Configuration.currentTouchpoint = 'checkout';
								Backbone.history.navigate('', { trigger: true });
							});
						}
						else {
							// Track Login Event
							self.trackEvent(function () {
								// if we know from which touchpoint the user is coming from
								if (url_options.origin && touchpoints[url_options.origin]) {
									// we save the url to that touchpoint
									var url = touchpoints[url_options.origin];
									// if there is an specific hash
									if (url_options.origin_hash) {
										// we add it to the url as a fragment
										url = Utils.addParamsToUrl(url, { fragment: url_options.origin_hash });
									}
									window.location.href = url;
								}
								else {
									// We've got to disable passwordProtectedSite feature if customer registration is disabled.
									if (Configuration.getRegistrationType() !== 'disabled' &&
										SC.ENVIRONMENT.siteSettings.siteloginrequired === 'T') {
										window.location.href = touchpoints.home;
									}
									else {
										// otherwise we need to take it to the customer center
										window.location.href = touchpoints.customercenter;
									}
								}
							});
						}
					});
				}
			}
		}
	};

	function redirectPost(url, data) {
		var form = document.createElement('form');
		document.body.appendChild(form);
		form.method = 'post';
		form.action = url;
		for (var name in data) {
			var input = document.createElement('input');
			input.type = 'hidden';
			input.name = name;
			input.value = data[name];
			form.appendChild(input);
		}

		console.log('url',url);
		console.log('data',data);

		form.submit();
	}

	function redirectUrl(url) {
		window.location.href = url;
	}

	function setCookie(cname, cvalue, exdays) {

		var d = new Date();
	  	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	  	var expires = "expires="+d.toUTCString();
	  	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

	}

	function userObject() {
		this.companyname;
		this.email;
	}

});
